import type {ElasticRecord, ONPRecord} from "~/types/record";

export type FilterKeys = 'products' | 'causes';
export const useRecords = () => {

    const getOnpListFromQuery = async (query: string,product:string): Promise<ONPRecord[]> => {

        const elasticRecords: ONPRecord[] = await $fetch(`/api/onp/getlist`, {
            method: 'GET',
            params: {
                query: query,
                product: product
            }
        })

        return elasticRecords;

    }

    const getOnpListFromKey = async (key: FilterKeys, value: string): Promise<ONPRecord[]> => {

        const elasticRecords: ONPRecord[] = await $fetch(`/api/onp/getlist`, {
            method: 'GET',
            params: {
                key: key,
                value: value
            }
        })

        return elasticRecords;

    }

    const getAllOnp = async (): Promise<ONPRecord[]> => {
        const elasticRecords: ElasticRecord[] = await $fetch(`/api/onp/getlist`, {
            method: 'GET',
        })

        return elasticRecords;
    }

    const getOnpData = async (id: string): Promise<ONPRecord> => {
        return await $fetch(`/api/onp/${id}`, {
            method: 'GET'
        })
    }

    const getOnpForCompany = async (): Promise<ONPRecord[]> => {
        return await $fetch(`/api/onp/company/getlist`, {
            method: 'GET'
        })
    }

    return {getOnpListFromQuery,getOnpListFromKey, getAllOnp, getOnpData,getOnpForCompany}
}